import { schema } from 'normalizr';
import assetSchema from './asset_schema';

const windowSchema = new schema.Entity('windows', {
  assets: [assetSchema],
  type: new schema.Entity('window_types'),
  catalog_entries: [new schema.Entity('catalog_entries')],
});

export default windowSchema;
